(function () {
  var M = window.OmniMoney = window.OmniMoney || {};
  var specs = {};

  function parse(sample) {
    var m = String(sample || '').match(/^([\s\S]*?)(\d(?:[\d\s.,']*\d)?)([\s\S]*)$/);
    if (!m) return { prefix: '$', suffix: '', thousands: ',', decimal: '.', decimals: 2 };
    var num = m[2];
    var seps = num.match(/[^\d]/g) || [];
    var decimal = '';
    var decimals = 0;
    var thousands = '';
    if (seps.length) {
      var last = seps[seps.length - 1];
      var trailing = num.length - num.lastIndexOf(last) - 1;
      if (trailing !== 3) {
        decimal = last;
        decimals = trailing;
      }
      for (var i = 0; i < seps.length; i++) {
        if (decimal && i === seps.length - 1) break;
        thousands = seps[i];
        break;
      }
    }
    return { prefix: m[1], suffix: m[3], thousands: thousands, decimal: decimal, decimals: decimals };
  }

  function spec(withCurrency) {
    var key = withCurrency ? 'code' : 'plain';
    if (!specs[key]) specs[key] = parse(withCurrency ? M.sampleCode : M.sample);
    return specs[key];
  }

  M.format = function (cents, opts) {
    opts = opts || {};
    var s = spec(!!opts.withCurrency);
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0;
    if (neg) n = -n;
    var pow = Math.pow(10, s.decimals);
    var whole = Math.floor(n / pow);
    var frac = n - whole * pow;
    var ws = String(whole);
    if (s.thousands) ws = ws.replace(/\B(?=(\d{3})+(?!\d))/g, s.thousands);
    var fs = '';
    if (s.decimals) {
      fs = String(frac);
      while (fs.length < s.decimals) fs = '0' + fs;
      fs = opts.trim && /^0+$/.test(fs) ? '' : s.decimal + fs;
    }
    return (neg ? '-' : '') + s.prefix + ws + fs + s.suffix;
  };

  M.url = function (path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || M.root || '/';
    return root.replace(/\/+$/, '') + '/' + String(path || '').replace(/^\/+/, '');
  };

  M.isBase = function () {
    return !M.code || M.code === M.shopCode;
  };

  var TOKEN = /\{(discount_max|discount_[123]x|price_[123]x|first_price_[123]x|per_day_[123]x)\}/g;
  var HAS_TOKEN = /\{(?:discount_max|discount_[123]x|price_[123]x|first_price_[123]x|per_day_[123]x)\}/;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1 };
  var sources = typeof WeakMap === 'function' ? new WeakMap() : null;

  function packValues() {
    var inputs = document.querySelectorAll('.nw-bundle-wrap input[data-pack]');
    var values = {};
    var max = null;
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var pack = input.getAttribute('data-pack');
      var pct = parseInt(input.getAttribute('data-percent'), 10);
      var price = parseInt(input.getAttribute('data-price'), 10);
      var finalCents = parseInt(input.getAttribute('data-final-cents'), 10);
      var perDay = parseInt(input.getAttribute('data-per-day-cents'), 10);
      if (!isNaN(pct)) {
        values['discount_' + pack] = String(pct);
        if (max === null || pct > max) max = pct;
      }
      if (!isNaN(price)) values['price_' + pack] = M.format(price, { trim: true });
      if (!isNaN(finalCents)) values['first_price_' + pack] = M.format(finalCents, { trim: true });
      if (!isNaN(perDay)) values['per_day_' + pack] = M.format(perDay, { trim: true });
    }
    if (max === null) max = derivedValues(values);
    if (max !== null) values.discount_max = String(max);
    return Object.keys(values).length ? values : null;
  }

  function derivedValues(values) {
    var max = null;
    var inputs = document.querySelectorAll('.nw-buybox-wrap input[data-pack], .gb-wrap input[data-pack]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var pack = input.getAttribute('data-pack');
      var price = parseInt(input.getAttribute('data-price'), 10);
      if (isNaN(price) || price <= 0) continue;
      var discountCents = Math.round((parseFloat(input.getAttribute('data-discount-amount')) || 0) * 100);
      var finalCents = price - discountCents;
      var days = parseInt(input.getAttribute('data-days'), 10);
      var pct = discountCents > 0 ? Math.round((discountCents / price) * 100) : 0;
      if (values['discount_' + pack] == null) values['discount_' + pack] = String(pct);
      if (values['price_' + pack] == null) values['price_' + pack] = M.format(price, { trim: true });
      if (values['first_price_' + pack] == null) values['first_price_' + pack] = M.format(finalCents, { trim: true });
      if (values['per_day_' + pack] == null && days > 0) values['per_day_' + pack] = M.format(Math.round(finalCents / days), { trim: true });
      if (pct > 0 && (max === null || pct > max)) max = pct;
    }
    if (max !== null) return max;
    max = badgeMax('.nw-bundle-item-discount-text');
    if (max !== null) return max;
    return badgeMax('.ph-badge');
  }

  function badgeMax(selector) {
    var max = null;
    var badges = document.querySelectorAll(selector);
    for (var j = 0; j < badges.length; j++) {
      var badge = parseInt((badges[j].textContent.match(/(\d+)\s*%/) || [])[1], 10);
      if (!isNaN(badge) && (max === null || badge > max)) max = badge;
    }
    return max;
  }

  M.applyTokens = function (root) {
    if (!sources || !document.createTreeWalker) return;
    var values = packValues();
    if (!values) return;
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (parent && SKIP[parent.nodeName]) continue;
      var source = sources.get(node);
      if (HAS_TOKEN.test(source != null ? source : node.nodeValue)) nodes.push(node);
    }
    for (var i = 0; i < nodes.length; i++) {
      var text = nodes[i];
      var original = sources.get(text);
      if (original == null) {
        original = text.nodeValue;
        sources.set(text, original);
      }
      text.nodeValue = original.replace(TOKEN, function (match, key) {
        return values[key] != null ? values[key] : match;
      });
    }
  };

  var retries = 0;
  function applyAll() {
    M.applyTokens();
    if (!packValues() && retries < 40) {
      retries++;
      setTimeout(applyAll, 300);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  window.addEventListener('load', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
})();
